import { Link, Typography, type TypographyProps } from '@mui/material'

export default function Copyright(props: TypographyProps) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {'Copyright © '}
      <Link color="inherit" href="https://pitbrain.com/">
        Pitbrain
      </Link>{' '}
      {new Date().getFullYear()}
      {'. '}
      <Link color="inherit" href="/privacy-policy.html">
        Privacy Policy
      </Link>
    </Typography>
  )
}
